export interface TokenData {
    token_type: string;
    access_token: string;
    expires_in: number;
    refresh_token: string;
    refresh_token_expires_in: number;
    expire_time: number;
}

export class Token {
    private SN_TOKEN = 'sn_token';

    public accessToken() {
        return this.data().access_token;
    }
    public refreshToken() {
        return this.data().refresh_token;
    }
    public data() {
        return (
            JSON.parse(localStorage.getItem(this.SN_TOKEN) || 'null') || {
                token_type: '',
                access_token: '',
                expires_in: 0,
                refresh_token: '',
                refresh_token_expires_in: 0,
                expire_time: 0,
            }
        );
    }
    public setData(newData: TokenData | undefined | null) {
        let data: TokenData;
        if (newData) {
            data = { ...this.data(), ...newData };
            data.expire_time = Date.now() + data.expires_in * 1000;
        } else {
            data = {
                token_type: '',
                access_token: '',
                expires_in: 0,
                refresh_token: '',
                refresh_token_expires_in: 0,
                expire_time: 0,
            };
        }
        localStorage.setItem(this.SN_TOKEN, JSON.stringify(data));
    }
    public accessTokenValid() {
        const authData = this.data();
        return authData.expire_time > Date.now();
    }
}
